// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__5Jtv6","checkbox-span":"checkbox_checkbox-span__IA9zs","checked":"checkbox_checked__bsWwJ"};